<template>
  <header class="site-header">
    <router-link class="brand" to="/">
      <img src="@/assets/image/LOGO.png" class="brand-logo" alt="博洛克供应链" />
    </router-link>

    <nav class="nav-links" aria-label="主导航">
      <router-link to="/" exact>首页</router-link>
      <router-link to="/AppSolution">应用方案</router-link>
    </nav>

  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style lang="less" scoped>
:deep(.el-tabs__nav) {
  width: 100%;

  .el-tabs__item {
    width: 50%;
    text-align: center;
  }
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  min-height: 76px;
  padding: 0 clamp(24px, 6vw, 96px);
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(18px);
}

.brand {
  display: inline-flex;
  align-items: center;
  min-width: 150px;
}

.brand-logo {
  display: block;
  width: 156px;
  height: auto;
}

.nav-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;

  a {
    position: relative;
    padding: 10px 14px;
    color: #344054;
    font-size: 15px;
    font-weight: 500;
    border-radius: 6px;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover,
    &.router-link-exact-active {
      color: #1268e8;
      background: #eef5ff;
    }
  }
}

@media screen and (max-width: 1024px) {
  .site-header {
    flex-wrap: wrap;
    gap: 16px;
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .nav-links {
    order: 3;
    flex-basis: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 2px;
  }

  .header-actions {
    min-width: auto;
  }
}

@media screen and (max-width: 640px) {
  .site-header {
    padding-left: 18px;
    padding-right: 18px;
  }

  .brand-logo {
    width: 132px;
  }

  .nav-links a {
    white-space: nowrap;
  }
}
</style>
